module.exports = __webpack_public_path__ + "img/MDI-motion-play-disabled.db650c31.svg";